// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_NonEmpty_CodeUnits from "../Data.String.NonEmpty.CodeUnits/index.js";
import * as Data_String_NonEmpty_Internal from "../Data.String.NonEmpty.Internal/index.js";
import * as Parsing from "../Parsing/index.js";
import * as Parsing_String from "../Parsing.String/index.js";
import * as URI_Common from "../URI.Common/index.js";
var alt = /* #__PURE__ */ Control_Alt.alt(Parsing.altParserT);
var show = /* #__PURE__ */ Data_Show.show(Data_String_NonEmpty_Internal.showNonEmptyString);
var map = /* #__PURE__ */ Data_Functor.map(Parsing.functorParserT);
var UserInfo = function (x) {
    return x;
};
var userInfoChar = /* #__PURE__ */ alt(URI_Common.unreserved)(/* #__PURE__ */ alt(URI_Common.subDelims)(/* #__PURE__ */ Parsing_String["char"](":")));
var unsafeToString = function (v) {
    return v;
};
var unsafeFromString = UserInfo;
var toString = function (v) {
    return URI_Common["decodeURIComponent$prime"](v);
};
var showUserInfo = {
    show: function (v) {
        return "(UserInfo.unsafeFromString " + (show(v) + ")");
    }
};
var semigroupUserInfo = Data_String_NonEmpty_Internal.semigroupNonEmptyString;
var print = function ($14) {
    return Data_String_NonEmpty_Internal.toString(unsafeToString($14));
};
var parser = /* #__PURE__ */ (function () {
    var parse = alt(map(Data_String_NonEmpty_CodeUnits.singleton)(userInfoChar))(URI_Common.pctEncoded);
    return map((function () {
        var $15 = Data_String_NonEmpty_Internal.join1With(Data_Array_NonEmpty_Internal.foldable1NonEmptyArray)("");
        return function ($16) {
            return UserInfo($15($16));
        };
    })())(Data_Array_NonEmpty.some(Parsing.alternativeParserT)(Parsing.lazyParserT)(parse));
})();
var ordUserInfo = Data_String_NonEmpty_Internal.ordNonEmptyString;
var fromString = /* #__PURE__ */ (function () {
    var $17 = URI_Common["printEncoded$prime"](userInfoChar);
    return function ($18) {
        return UserInfo($17($18));
    };
})();
var eqUserInfo = Data_String_NonEmpty_Internal.eqNonEmptyString;
export {
    fromString,
    toString,
    unsafeFromString,
    unsafeToString,
    parser,
    print,
    userInfoChar,
    eqUserInfo,
    ordUserInfo,
    semigroupUserInfo,
    showUserInfo
};
//# sourceMappingURL=index.js.map
